import { Button, Input } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

const StaffListHeader = ({ keyword, setKeyword, setPage }) => {
  const history = useHistory();

  return (
    <div className="header">
      <div className="actions">
        <Button
          type="primary"
          onClick={() => {
            history.push({
              pathname: "/main/setting/staff/edit",
            });
          }}
        >
          {i18n.t("merchantStaff.add")}
        </Button>
      </div>
      <div className="search">
        <Input
          defaultValue={keyword}
          allowClear
          onChange={(e) => {
            setKeyword(e.target.value);
            if (setPage) {
              setPage(1);
            }
          }}
          placeholder={i18n.t("merchantStaff.searchPlaceholder")}
        />
      </div>
    </div>
  );
};

export default StaffListHeader;
